import api from './api'

const url = '/blogs-categories'

export const getBlogCategories = async (data) =>
    api({
        url: url,
        data,
    });